import { render, staticRenderFns } from "./contractDocuments.vue?vue&type=template&id=5908bf9d&"
import script from "./contractDocuments.vue?vue&type=script&lang=js&"
export * from "./contractDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports